module.exports = __webpack_public_path__ + "static/media/girl-images.493784b9.png";